import buildResourceActions from 'store/configure/actions';

const resourceActions = buildResourceActions('usersV2');

export default resourceActions;
